module.exports = __webpack_public_path__ + "img/candidates.14646741.svg";